<div
    class="d-flex align-items-center justify-content-center badge rounded-pill visibility {{ WORKFLOW_BADGE_LABELS_MAP[visibility]?.cssClass }}"
    [title]="'WORKFLOWS.WORKFLOW_STATUS' | translate"
    data-uit="workflow-badge-text"
>
    {{ WORKFLOW_BADGE_LABELS_MAP[visibility]?.translationKey | translate }}
</div>
